import type { App } from 'vue'
import { VueResponsiveness, Presets } from 'vue-responsiveness'

export const setVueResponsiveness = async (app: App<Element>) => {
  /**
   * 预设bootstrap5的响应式系统
   * https://getbootstrap.com/docs/5.0/layout/breakpoints/
   */
  app.use(VueResponsiveness, Presets.Bootstrap_5)
}